"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitedTextField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var Text_1 = require("../../atoms/Text");
var TextField_1 = require("../../atoms/TextField");
var styles_1 = __importDefault(require("./styles"));
var atoms_1 = require("../../atoms");
var LimitedTextField = function (_a) {
    var maxLength = _a.maxLength, helperTextDefault = _a.helperText, enclosed = _a.enclosed, enclosedTextFieldProps = _a.enclosedTextFieldProps, regularTextFieldProps = _a.regularTextFieldProps, _b = _a.showHelperText, showHelperText = _b === void 0 ? true : _b, props = __rest(_a, ["maxLength", "helperText", "enclosed", "enclosedTextFieldProps", "regularTextFieldProps", "showHelperText"]);
    var defaultValue = props.defaultValue, value = props.value, onChange = props.onChange, error = props.error;
    var _c = (0, react_1.useState)((value || defaultValue || "").length), textLength = _c[0], setTextLength = _c[1];
    var handleChange = (0, react_1.useCallback)(function (event) {
        setTextLength(event.target.value.length);
        if (onChange) {
            onChange(event);
        }
    }, [onChange, setTextLength]);
    // just in case having inconsitency with controlled inputs.
    var charCount = (value === null || value === void 0 ? void 0 : value.length) || textLength;
    var maxLengthExceeded = charCount > maxLength;
    var helperText = maxLengthExceeded
        ? "Character limit exceeded"
        : helperTextDefault;
    var showError = error || maxLengthExceeded;
    var classes = (0, styles_1.default)({ error: showError, enclosed: enclosed });
    var HelperText = react_1.default.memo(function () { return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ className: classes.textLength, color: "text.secondary", component: "span" }, { children: [showHelperText ? ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ weight: showError ? "bold" : "regular", sx: { fontSize: "12px" } }, { children: helperText }))) : ((0, jsx_runtime_1.jsx)("span", {})), !enclosed && ((0, jsx_runtime_1.jsxs)(Text_1.Text, { children: [charCount, "/", maxLength] }))] }))); });
    var Component = enclosed ? atoms_1.EnclosedTextField : TextField_1.TextField;
    return ((0, jsx_runtime_1.jsx)(Component, __assign({}, props, { classes: { root: classes.root }, onChange: handleChange, error: showError, helperText: (0, jsx_runtime_1.jsx)(HelperText, {}), maxLength: maxLength, InputProps: enclosed
            ? {
                endAdornment: ((0, jsx_runtime_1.jsx)(core_1.InputAdornment, __assign({ position: "end" }, { children: (0, jsx_runtime_1.jsxs)(Text_1.Text, __assign({ className: classes.endAdornment }, { children: [charCount, "/", maxLength] })) }))),
            }
            : {} }, enclosedTextFieldProps, regularTextFieldProps)));
};
exports.LimitedTextField = LimitedTextField;
